import { useEffect, useState } from "react";

export type SWCheckResult = "loading" | "ok" | "not_supported" | "not_registered" | "no_controller";

export function useSWCheck(): SWCheckResult {
  const [result, setResult] = useState<SWCheckResult>("loading");

  useEffect(() => {
    if (!("serviceWorker" in navigator)) {
      setResult("not_supported");
      return;
    }
    navigator.serviceWorker
      .getRegistration()
      .then((reg) => {
        if (!reg) return setResult("not_registered");
        if (!navigator.serviceWorker.controller) return setResult("no_controller");
        setResult("ok");
      })
      .catch(() => setResult("not_registered"));
  }, []);

  return result;
}
